import store from '@polleverywhere/redux'
import { slice as profileSlice } from '@polleverywhere/redux/slices/profile'
import URI from 'urijs'
import { peUrlParams } from '../../entry/util/peUrlParams'
import destroySession from './destroy_session'

const LOGOUT_PARAM = 'forceLogout'

/**
 * Checks URL params for force logout flag and automatically logs you out if so
 */
export default async function forceLogoutWhenParamExists (state) {
  const params = peUrlParams()

  // Always remove this param immediately, otherwise SSO redirects may autologout again
  if (params.has(LOGOUT_PARAM)) {
    const uri = URI(window.location.href)
    window.history.replaceState('', '', uri.removeSearch(LOGOUT_PARAM).toString())
  }

  // Short circuit if not actually logged in
  if (!profileSlice.selectIsLoggedIn(store.getState())) {
    return false
  }

  // If forced to logout, ask the state to do that and return true
  if (params.get(LOGOUT_PARAM) === 'true') {
    await destroySession()
    return true
  }

  return false
}
